module.exports = __webpack_public_path__ + "static/media/three_lady_03-blink.1d051fbb.png";